<svg
  [style]="{ color: color }"
  style="width: 100%; height: 100%;"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <use [attr.href]="'/assets/icons/' + name + '.svg#' + name"></use>
</svg>
